import './styles.css'
import { initLiff } from './liff'
import { routes, ENABLED_ROUTES, GATED_ROUTES, renderNeedLink } from './routes'
import { renderError } from './ui'
import { loadSession, isLinked } from './session'

const app = document.getElementById('app') as HTMLElement

async function render(): Promise<void> {
  const path = location.pathname.replace(/\/+$/, '') || '/'
  if (GATED_ROUTES.has(path) && !isLinked()) {
    renderNeedLink(app)
    return
  }
  const route = (ENABLED_ROUTES.has(path) && routes[path]) || routes['/']!
  app.innerHTML = `<div class="loading">กำลังโหลด…</div>`
  try {
    await route(app)
  } catch (err) {
    renderError(app, err instanceof Error ? err.message : String(err))
  }
}

addEventListener('popstate', render)

initLiff()
  .then(loadSession)
  .then(render)
  .catch((err) => renderError(app, `เริ่มต้น LIFF ไม่สำเร็จ: ${err instanceof Error ? err.message : String(err)}`))
